import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePartnerCrmAccess = () => {
  return useQuery({
    queryKey: ["partner-crm-access"],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return false;

      console.log("🔍 [PartnerCrmAccess] Checking partner record for user:", session.user.id);

      const { data: partner, error } = await supabase
        .from('crm_partners')
        .select('id')
        .eq('user_id', session.user.id)
        .maybeSingle();

      if (error) {
        console.error("❌ [PartnerCrmAccess] Error checking partner record:", error);
        return false;
      }

      const hasAccess = !!partner;
      console.log("🔑 [PartnerCrmAccess] Partner CRM access granted:", hasAccess);
      return hasAccess;
    }
  });
};
